app.ApiTokenList = app.AbstractCollection.extend({
  model: app.ApiToken,

  url() {
    return '/api/v2/api-tokens';
  },
});
